import React, { FC } from 'react'
import { useField } from 'formik'
import { useTranslations } from 'next-intl'
import { MIDDLE_NAME_FIELD_NAME } from '../constants'
import { IFormValue } from '../../../validator/IFormValues'
import { Field } from '../../Field/Field'

type FormMiddleNameFieldProps = {
  validate?: (name: string) => (currentValue: IFormValue) => Promise<string>
}

export const FormMiddleNameField: FC<FormMiddleNameFieldProps> = ({ validate }) => {
  const t = useTranslations()
  const [field] = useField('middleName')
  const middleNameFieldName = t(MIDDLE_NAME_FIELD_NAME)

  return <Field name={field.name} label={middleNameFieldName} validate={validate && validate(field.name)} />
}

FormMiddleNameField.displayName = 'FormMiddleNameField'
